import {
  CmsPageContentIdentifier,
  CmsTariffContentType,
  CmsTariffDescriptionType,
  TariffOfferType
} from '@/types/av-check';

import { camelCase } from "lodash";

// use a different color to mark content based on its origin
const colorForCmsContentUrl = (url: string) => {
  if (url.includes('/api')) {
    return '209, 2, 27';
  }
  if (url.includes('/snippet')) {
    return '255, 204, 0';
  }
  return '74, 144, 226';
};

function wrapContentFromString(cmsContent: string, cmsUrl: string) {
  const color = colorForCmsContentUrl(cmsUrl);

  return `${'<div style="'
        + 'border: 2px solid rgba('}${color}, 1); `
        + `background-color: rgba(${color}, 0.3);" `
        + `title="CMS Pfad = '${cmsUrl}'">${
          cmsContent
        }</div>`;
}

export function renderCmsContent(cmsTariffContent: CmsTariffContentType): string {
  if (cmsTariffContent.debugInfo) {
    return wrapContentFromString(cmsTariffContent.content, cmsTariffContent.debugInfo.url);
  }
  return cmsTariffContent.content;
}

function renderedCmsContent(cmsTariffContent: CmsTariffContentType): CmsTariffContentType {
  return {
    ...cmsTariffContent,
    rendered: renderCmsContent(cmsTariffContent),
  };
}

function renderedCmsDescription(cmsTariffDescriptionType: CmsTariffDescriptionType): CmsTariffDescriptionType {
  return {
    name: renderedCmsContent(cmsTariffDescriptionType.name),
    shortName: renderedCmsContent(cmsTariffDescriptionType.shortName),
    downloadBandwidthWithIcon: renderedCmsContent(cmsTariffDescriptionType.downloadBandwidthWithIcon),
    downloadBandwidthText: renderedCmsContent(cmsTariffDescriptionType.downloadBandwidthText),
    downloadBandwidthUnit: renderedCmsContent(cmsTariffDescriptionType.downloadBandwidthUnit),
    features: cmsTariffDescriptionType.features.map((feature) => renderedCmsContent(feature)),
    featuresShort: cmsTariffDescriptionType.featuresShort.map((featureShort) => renderedCmsContent(featureShort)),
    uploadBandwidth: renderedCmsContent(cmsTariffDescriptionType.uploadBandwidth),
    pibLink: renderedCmsContent(cmsTariffDescriptionType.pibLink),
    accessTechnologyDescription: renderedCmsContent(cmsTariffDescriptionType.accessTechnologyDescription)
  };
}

export function withRenderedCmsContent(tariffOffers: TariffOfferType[]): TariffOfferType[] {
  return tariffOffers.map((tariffOffer) => ({
    ...tariffOffer,
    cmsTariffDescription: renderedCmsDescription(tariffOffer.cmsTariffDescription),
  }));
}

const stairSchemaClasses = () => (
  [
    'teaser-primary', 'teaser-secondary', 'teaser-tertiary', 'teaser-quaternary', 'teaser-quinary',
    'teaser-senary', 'teaser-septenary', 'teaser-octonary', 'teaser-nonary', 'teaser-denary',
  ]
);

const stairSchemaClassesForAmountOfTariffs = (amountOfTariffs: number) => stairSchemaClasses().slice(-amountOfTariffs);

export function getStairSchemaClassForIndex(index: number, amountOfTariffs: number) {
  if (index >= stairSchemaClassesForAmountOfTariffs(amountOfTariffs).length) {
    return '';
  }

  return stairSchemaClassesForAmountOfTariffs(amountOfTariffs)[index];
}

export function getCMSSnippetForDisplayPriceItemId(itemId: string): CmsPageContentIdentifier {
  return camelCase(itemId) as CmsPageContentIdentifier;
}
